import { render, staticRenderFns } from "./SimpleChildTable.vue?vue&type=template&id=40f15c99&scoped=true"
import script from "./SimpleChildTable.vue?vue&type=script&lang=js"
export * from "./SimpleChildTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f15c99",
  null
  
)

export default component.exports